import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/devicepart/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/devicepart/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/devicepart/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/devicepart/save', params,options)

export const update = (params, options) =>
request.post('/api/devicepart/update', params,options)
